
import React, { useEffect, useMemo, useRef, useState } from 'react';

const useVisibleCount = () => {
  const [count, setCount] = useState(8); // Reduzido o padrão para dar mais respiro
  useEffect(() => {
    const calc = () => {
      const w = window.innerWidth;
      if (w <= 480) setCount(4); // Menos itens no mobile
      else if (w <= 768) setCount(5);
      else if (w <= 1280) setCount(7);
      else setCount(8);
    };
    calc();
    window.addEventListener('resize', calc);
    return () => window.removeEventListener('resize', calc);
  }, []);
  return count;
};


const getWindowWithWrap = (list, startIndex, visibleCount) => {
  if (!list.length || visibleCount <= 0) return [];
  const result = [];
  for (let i = 0; i < visibleCount; i++) {
    const idx = (startIndex + i) % list.length;
    result.push(list[idx]);
  }
  return result;
};

const BannerExpositores = ({ expositores, onLogoClick, intervalMs = 3000, posicao = 'topo' }) => {
  const base = useMemo(
    () => (expositores || []).filter(e => e?.expositor?.logoUrl),
    [expositores]
  );

  const visibleCount = useVisibleCount();
  const [startIndex, setStartIndex] = useState(() => 
    base.length ? Math.floor(Math.random() * base.length) : 0
  );

  const pausedRef = useRef(false);

  useEffect(() => {
    if (!base.length) return;
    const id = setInterval(() => {
      if (!pausedRef.current) {
        setStartIndex(prev => (prev + 1) % base.length); // Avança de 1 em 1 para suavizar
      }
    }, intervalMs);
    return () => clearInterval(id);
  }, [base.length, intervalMs]);

  const windowItems = useMemo(
    () => getWindowWithWrap(base, startIndex, visibleCount),
    [base, startIndex, visibleCount]
  );

  if (!base.length) return null;

  const containerStyle = posicao === 'rodape' ? {
    position: 'absolute',
    bottom: 0,
    left: 0,
    zIndex: 1001, // Menor que o FooterDev
    borderTop: '1px solid #ddd',
    width: '100%'
  } : {};

return (
  <div
    className="logo-strip-container"
    onMouseEnter={() => (pausedRef.current = true)}
    onMouseLeave={() => (pausedRef.current = false)}
  >
    <div className="logo-strip__track">
      {windowItems.map((estande, i) => (
        <button
          key={`${estande.expositor_id}-${startIndex}-${i}`}
          className="logo-strip__item"
          style={{ border: 'none', outline: 'none' }} // Limpa resíduos de botões
          onClick={() => onLogoClick?.(estande.expositor)}
        >
          <img
            src={estande.expositor.logoUrl}
            alt={estande.expositor.nome}
            loading="lazy"
          />
        </button>
      ))}
    </div>
  </div>
);
};

export default BannerExpositores;